// extracted by mini-css-extract-plugin
module.exports = {"scrollLoader":"ScrollLoader_scrollLoader__1YkKW","loader":"ScrollLoader_loader__1dMkw"};